import script from "./AltarBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarBuilder.vue?vue&type=script&setup=true&lang=js"

import "./AltarBuilder.vue?vue&type=style&index=0&id=2a430e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a430e02"]])

export default __exports__